// AUTO-GENERATED FILE. Do not edit by hand.
//
// This file is rebuilt by /app/frontend/scripts/generate-assets.js
// before every `yarn start` and `yarn build` (see package.json
// "prestart" and "prebuild" hooks).
//
// To change a tile:
//   * Rename / add / remove a file in /app/frontend/public/assets/<folder>/
//     -> manifest updates automatically on next dev-server restart.
//   * To override title, set a custom link, or mark a video as portrait,
//     edit /app/frontend/scripts/asset-overrides.json
//
// Generated: 2026-09-19T15:58:18.174Z

export const BRAND = {
  "logo": "/assets/brand/uprcse-logo.png",
  "founder": "/assets/brand/utpal-biswas.png",
  "advisor": "/assets/brand/kuntal-biswas.jpeg"
};

export const BRANDING = [
  {"src":"/assets/branding/Bauli-Dispiay1.jpg","title":"Bauli - Dispiay 1"},
  {"src":"/assets/branding/Bauli-Display2.jpg","title":"Bauli - Display 2"},
  {"src":"/assets/branding/Valeo-Canopy.jpg","title":"Valeo - Canopy"},
  {"src":"/assets/branding/Valeo-SelfieStand.jpg","title":"Valeo - Selfie Stand"},
  {"src":"/assets/branding/Valmet-Giveaways.jpg","title":"Valmet - Giveaways"},
];

export const PACKAGING = [
  {"src":"/assets/packaging/BatteryCarton.webp","title":"Battery Carton"},
  {"src":"/assets/packaging/BatteryLabel.webp","title":"Battery Label"},
  {"src":"/assets/packaging/EggTray.webp","title":"Egg Tray"},
  {"src":"/assets/packaging/inverterBattery.webp","title":"Inverter Battery"},
  {"src":"/assets/packaging/InverterBatteryLabel.webp","title":"Inverter Battery Label"},
  {"src":"/assets/packaging/Navatek.webp","title":"Navatek"},
];

export const LOGOS = [
  {"src":"/assets/logos/Be-jewelled-Logo.jpg","title":"Be - Jewelled - Logo","ratio":"aspect-square","fit":"contain"},
  {"src":"/assets/logos/Bizinsights-Logo.jpg","title":"Bizinsights - Logo","ratio":"aspect-square","fit":"contain"},
  {"src":"/assets/logos/GamakaBox-Logo.jpg","title":"Gamaka Box - Logo","ratio":"aspect-square","fit":"contain"},
  {"src":"/assets/logos/GiftingArt-Logo.jpg","title":"Gifting Art - Logo","ratio":"aspect-square","fit":"contain"},
  {"src":"/assets/logos/Gurusish.jpg","title":"Gurusish","ratio":"aspect-square","fit":"contain"},
  {"src":"/assets/logos/JustBatteries-Logo.jpg","title":"Just Batteries - Logo","ratio":"aspect-square","fit":"contain"},
  {"src":"/assets/logos/MPL-Logo.jpg","title":"MPL - Logo","ratio":"aspect-square","fit":"contain"},
  {"src":"/assets/logos/RameshVinayakam-Logo.jpg","title":"Ramesh Vinayakam - Logo","ratio":"aspect-square","fit":"contain"},
];

export const STALLS = [
  {"src":"/assets/stalls/DCC-Garknit-Kolkata-Sep26.jpg","title":"DCC - Garknit - Kolkata - Sep 2026"},
  {"src":"/assets/stalls/DCC-JioConvention-May25.jpg","title":"DCC - Jio Convention - May 2025"},
  {"src":"/assets/stalls/DCC-Kolkata.jpg","title":"DCC - Kolkata"},
  {"src":"/assets/stalls/DCC-Mumbai-April26.jpeg","title":"DCC - Mumbai - April 2026"},
  {"src":"/assets/stalls/DCC-Mumbai-Dec25.jpg","title":"DCC - Mumbai - Dec 2025"},
  {"src":"/assets/stalls/DCC-Mumbai.jpg","title":"DCC - Mumbai"},
  {"src":"/assets/stalls/DCC-NewDelhi-Aug26.jpg","title":"DCC - New Delhi - Aug 2026"},
  {"src":"/assets/stalls/DCC-Tiruppur-Aug26.jpg","title":"DCC - Tiruppur - Aug 2026"},
  {"src":"/assets/stalls/Exide-Chennai-July26.jpg","title":"Exide - Chennai - July 2026"},
  {"src":"/assets/stalls/Exide-Chennai.jpg","title":"Exide - Chennai"},
  {"src":"/assets/stalls/Exide-IndiaExpo-Noida-Feb24.webp","title":"Exide - India Expo - Noida - Feb 2024"},
  {"src":"/assets/stalls/Exide-Mumbai.jpg","title":"Exide - Mumbai"},
  {"src":"/assets/stalls/Exide-Pune-May25.jpg","title":"Exide - Pune - May 2025"},
  {"src":"/assets/stalls/Exide-Warehousing-Mumbai.jpg","title":"Exide - Warehousing - Mumbai"},
  {"src":"/assets/stalls/Exide-Yashobhumi-Delhi-June26.jpeg","title":"Exide - Yashobhumi - Delhi - June 2026"},
  {"src":"/assets/stalls/Exide-Yashobhumi-June25.jpeg","title":"Exide - Yashobhumi - June 2025"},
  {"src":"/assets/stalls/NanovaceStall.jpg","title":"Nanovace Stall"},
  {"src":"/assets/stalls/PCBL-Feb26.jpg","title":"PCBL - Feb 2026"},
  {"src":"/assets/stalls/PCBL-Yashobhumi-Delhi-July25.jpeg","title":"PCBL - Yashobhumi - Delhi - July 2025"},
  {"src":"/assets/stalls/RDI-DesignerVillage-May26.jpg","title":"RDI - Designer Village - May 2026"},
  {"src":"/assets/stalls/Valeo_Bengaluru.jpg","title":"Valeo - Bengaluru"},
  {"src":"/assets/stalls/Valeo_Namakaal.jpg","title":"Valeo - Namakaal"},
  {"src":"/assets/stalls/Valeo-Raipur.jpg","title":"Valeo - Raipur"},
];

export const RETAIL = [
  {"src":"/assets/retail/Camrola-Navi Mumnai.jpg","title":"Camrola - Navi Mumnai"},
  {"src":"/assets/retail/Valeo-Chandigarh.jpg","title":"Valeo - Chandigarh"},
  {"src":"/assets/retail/Valeo-Ghaziabad.jpg","title":"Valeo - Ghaziabad"},
  {"src":"/assets/retail/Valeo-NewDelhi.jpg","title":"Valeo - New Delhi"},
];

export const WEBSITES = [
  {"src":"/assets/websites/Uprcse.png","title":"UPRCSE","link":"https://www.uprcse.com/"},
  {"src":"/assets/websites/PSLCote.png","title":"PSL Cote","link":"https://pslcote.com/"},
  {"src":"/assets/websites/SenAndCo.png","title":"Sen & Company","link":"https://www.senandcompany.in/"},
  {"src":"/assets/websites/SGAStrat.png","title":"SGA Strat","link":"https://sgastrat.com/"},
];

export const CONTENT = [
  {"src":"/assets/videos/ExideExpoVideo.mp4","title":"Exide - Expo Film","type":"video","orientation":"landscape"},
  {"src":"/assets/videos/RajiHeritageLooms.mp4","title":"Raji Heritage Looms - Brand Film","type":"video","orientation":"portrait"},
  {"src":"/assets/videos/Selenide.mp4","title":"Selenide - Product Film","type":"video","orientation":"landscape"},
];

export const CATEGORY_GROUPS = [
  {
    id: "stalls",
    number: "01",
    label: "Exhibition & Stalls",
    title: "Wireframe to walk-through. End-to-end fabrication.",
    items: STALLS,
  },
  {
    id: "retail",
    number: "02",
    label: "Retail & RCIP Outlets",
    title: "One identity. Replicated across geographies.",
    items: RETAIL,
  },
  {
    id: "websites",
    number: "03",
    label: "Website & Digital",
    title: "Static information turned into engaging digital experiences.",
    items: WEBSITES,
  },
  {
    id: "content",
    number: "04",
    label: "Content & Media",
    title: "Brand films and product stories - produced in-house.",
    items: CONTENT,
  },
  {
    id: "branding",
    number: "05",
    label: "Branding & Identity",
    title: "Identity systems applied across every touchpoint.",
    items: [...BRANDING, ...PACKAGING, ...LOGOS],
  },
];
